import { auth } from "./firebase";
import { getValidToken } from "./token-store";

export const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8789";

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = auth.currentUser
    ? await auth.currentUser.getIdToken()
    : await getValidToken();

  if (!token) throw new Error("Not authenticated");

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  if (body !== undefined) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const json = await res.json() as { success: boolean; data?: T; error?: { message: string } };
  if (!json.success) throw new Error(json.error?.message ?? "Request failed");
  return json.data as T;
}

export const apiGet = <T>(path: string) => request<T>("GET", path);
export const apiPost = <T>(path: string, body: unknown) => request<T>("POST", path, body);
export const apiPut = <T>(path: string, body: unknown) => request<T>("PUT", path, body);
export const apiDelete = <T>(path: string) => request<T>("DELETE", path);

export interface SubscriptionData {
  planId: string;
  status: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  priceId?: string;
}

export const billing = {
  getSubscription: () => apiGet<SubscriptionData>("/api/billing/subscription"),
  createCheckout: (body: { priceId: string; successUrl: string; cancelUrl: string }) =>
    apiPost<{ url: string; sessionId: string }>("/api/billing/checkout", body),
  createPortal: (body: { returnUrl: string }) =>
    apiPost<{ url: string }>("/api/billing/portal", body),
};
